import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalContext,
  PaginationContext,
  Text,
  toast,
  useServerResponseTranslation,
} from 'dash-ui';

import {
  GetPropertyNotesDocument,
  useRemovePropertyNoteMutation,
} from 'gql/generated.graphql';

function DeletePropertyNoteModal({ propertyId }: { propertyId: string }) {
  const { t: tPropertyPage } = useTranslation('pages', {
    keyPrefix: 'propertyPage',
  });
  const { t: tLabels } = useTranslation('common', {
    keyPrefix: 'labels',
  });
  const translateServerResponse = useServerResponseTranslation();
  const { state: paginationState, getRefetchProps } =
    useContext(PaginationContext);
  const { skip, limit } = getRefetchProps(paginationState);

  const { isOpenCurrent, payload, toggleModal, setPayload } =
    useContext(ModalContext);
  const isOpen = isOpenCurrent['DeletePropertyNoteModal'];

  const [removePropertyNote, { loading }] = useRemovePropertyNoteMutation({
    refetchQueries: [
      {
        query: GetPropertyNotesDocument,
        variables: {
          propertyId,
          pagination: { skip, limit },
        },
      },
    ],
  });

  function closeModal() {
    setPayload(null);
    toggleModal(false, 'DeletePropertyNoteModal');
  }

  function submitPropertyDelete() {
    removePropertyNote({
      variables: { propertyNoteId: payload.propertyNoteId },
    })
      .then(closeModal)
      .catch((error) => toast.error(translateServerResponse(error)));
  }

  return (
    <Modal
      isOpen={isOpen}
      title={tPropertyPage`deletePropertyNote` || ''}
      onRequestClose={closeModal}
      cancelButton={{
        title: tLabels`cancel`,
        onClick: closeModal,
      }}
      submitButton={{
        title: tLabels`delete`,
        onClick: submitPropertyDelete,
        colorVariation: 'danger',
        isLoading: loading,
      }}
    >
      <Text>{tPropertyPage`deletePropertyNoteModalConfirmationText`}</Text>
    </Modal>
  );
}

export default DeletePropertyNoteModal;
